var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "team-form" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "forms",
              attrs: {
                inline: true,
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "106px",
              },
            },
            [
              _c("div", { staticClass: "text" }, [_vm._v("考勤组信息")]),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "block" },
                      attrs: { label: "考勤组名称", prop: "name" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "550px" },
                        attrs: {
                          placeholder: "请输入考勤组名称",
                          maxlength: "30",
                          clearable: "",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "考勤组负责人", prop: "managerUserList" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          key: "main",
                          staticClass: "select-u",
                          attrs: {
                            "value-key": "name",
                            placeholder: "请选择考勤组负责人",
                            "collapse-tags": "",
                            size: "medium",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openUserPicker("add", "leader")
                            },
                          },
                          model: {
                            value: _vm.form.managerUserList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "managerUserList", $$v)
                            },
                            expression: "form.managerUserList",
                          },
                        },
                        _vm._l(
                          _vm.form.managerUserList,
                          function (user, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: user.serial + " " + user.name,
                                value: user,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "考勤人员", prop: "memberUserList" } },
                    [
                      _c(
                        "el-select",
                        {
                          key: "main",
                          staticClass: "select-u",
                          class:
                            _vm.form.memberUserList.length > 1
                              ? "select-more"
                              : "",
                          attrs: {
                            "value-key": "name",
                            placeholder: "请选择考勤人员",
                            "collapse-tags": "",
                            size: "medium",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openUserPicker("add", "member")
                            },
                          },
                          model: {
                            value: _vm.form.memberUserList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "memberUserList", $$v)
                            },
                            expression: "form.memberUserList",
                          },
                        },
                        _vm._l(_vm.form.memberUserList, function (user, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: user.serial + " " + user.name,
                              value: user,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "text" }, [_vm._v("考勤设置")]),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "block" },
                      attrs: { label: "考勤班次", prop: "shiftIds" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "550px" },
                          attrs: {
                            multiple: "",
                            placeholder: "请选择考勤班次",
                          },
                          model: {
                            value: _vm.form.shiftIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shiftIds", $$v)
                            },
                            expression: "form.shiftIds",
                          },
                        },
                        _vm._l(_vm.shiftListAll, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.label, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "打卡地点",
                        prop: "addresss",
                        required: "",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "550px" },
                        attrs: { disabled: true, value: _vm.form.addresss },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效范围", prop: "rangeMeters" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.rangeMeters,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "rangeMeters", $$v)
                            },
                            expression: "form.rangeMeters",
                          },
                        },
                        _vm._l(10, function (index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: 100 * index + "米",
                              value: 100 * index,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "block" },
                      attrs: { label: " ", "label-width": "40px" },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.repairEnabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "repairEnabled", $$v)
                            },
                            expression: "form.repairEnabled",
                          },
                        },
                        [_vm._v("允许补卡")]
                      ),
                    ],
                    1
                  ),
                  _vm.form.repairEnabled
                    ? [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "300px" },
                            attrs: {
                              label: "每月可提交",
                              prop: "monthlyRepairQuota",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "50px" },
                              attrs: { maxlength: "2" },
                              on: {
                                input: function ($event) {
                                  return _vm.onCheckInput(
                                    $event,
                                    "monthlyRepairQuota"
                                  )
                                },
                              },
                              model: {
                                value: _vm.form.monthlyRepairQuota,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "monthlyRepairQuota", $$v)
                                },
                                expression: "form.monthlyRepairQuota",
                              },
                            }),
                            _vm._v("次补卡 "),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "300px" },
                            attrs: { label: "每月", prop: "repairResetDay" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "50px" },
                              attrs: { maxlength: "2" },
                              on: {
                                input: function ($event) {
                                  return _vm.onCheckInput(
                                    $event,
                                    "repairResetDay"
                                  )
                                },
                              },
                              model: {
                                value: _vm.form.repairResetDay,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "repairResetDay", $$v)
                                },
                                expression: "form.repairResetDay",
                              },
                            }),
                            _vm._v("日起重新计算 "),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.reset },
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnSave },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickerDialog.title, multiple: true },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }